import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import i18n from './plugins/i18n'
import router from "@/router"
import vuetify from './plugins/vuetify'
import axios from 'axios'

require('@/assets/css/app.css')
Vue.use(axios);
Vue.config.productionTip = false

axios.interceptors.request.use(function (config) {
  if (config.url.startsWith('https://web-admin.sum.ba/api/web/')){
    config.headers.accept = "application/json";
    config.headers.language = localStorage.language_seejc;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo, {
  container: "body",
  duration: 2500,
  offset: -80,
})

new Vue({
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
